/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./MentorDashboard.scss";
import useMentorDashboard from "./useMentorDashboard";
import CalendarDashboardComponent from "../../../_uiComponents/CalendarDashboardComponent";
import AssessmentKits from "./components/AssessmentKits";
import { Spinner, Modal, Tab, Tabs } from "react-bootstrap";
import MainLayout from "../../../_components/Common/MainLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";

export default (props) => {
  const {
    assessmentKits,
    assesmentKitsLoading,
    mentorProfile,
    resumeUploadModal,
    isResumeUpload,
    suggestedCandidates,
    suggestedCandidatesLoading,

    onEditKitClick,
    onViewAssessmentsClick,
    onViewCandidatesClick,
    handleResumeUploadModal,
    onResumeUpload,
    onClickNewAssessment,
    onViewAllCandidatesClick,
    onViewCandidateProfileClick,
    onShareProfileClick
  } = useMentorDashboard();

  return (
    <MainLayout activeMenuItem="home" pageName="Dashboard" user={mentorProfile} handleResumeUploadModal={handleResumeUploadModal} onShare={onShareProfileClick}>
      <div className="mentor-dashboard-new bg-grey-4 position-relative footer-gap">
        <div className="hiring-board">
          <div className="container">
            <div className="row mb-3">
              <div className="col-xl-8 pb-4">
                <AssessmentKits
                  assessmentKits={assessmentKits}
                  assesmentKitsLoading={assesmentKitsLoading}
                  onEditKitClick={onEditKitClick}
                  onViewAssessmentsClick={onViewAssessmentsClick}
                  onViewCandidatesClick={onViewCandidatesClick}
                  onClickNewAssessment={onClickNewAssessment}
                />
              </div>

              <div className="col-xl-4 mb-4">
                <div className="dashboard-component-container bg-white border border-radius-10 h-100 p-3 mt-3 dashboard-mentor-list">
                  <div className="d-flex align-items-center justify-content-between ">
                    <h4>Connect with Talents</h4>
                    <p className="text-primary font-weight-medium cursor-pointer"
                      onClick={onViewAllCandidatesClick}
                    >
                      View All
                    </p>
                  </div>
                  <Tabs defaultActiveKey="Candidates" className="mt-3">
                    <Tab eventKey="Candidates" title="Candidates">
                      <div className="mt-3">
                      
                        {suggestedCandidatesLoading ? (
                          <div className="d-flex justify-content-center align-items-center w-100">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        ) : suggestedCandidates?.data &&
                          Array.isArray(suggestedCandidates?.data) &&
                          suggestedCandidates.data.length ? (
                          <ul className="mentor-list">
                            {suggestedCandidates?.data &&
                              Array.isArray(suggestedCandidates.data) &&
                              suggestedCandidates.data.map((item) => (
                                <li
                                  className="mentor-box bg-grey d-flex align-items-center"
                                  onClick={() =>
                                    onViewCandidateProfileClick(
                                      item?.user_details &&
                                      item.user_details?.hash_id
                                    )
                                  }
                                  key={item?.id}
                                >
                                  <div className="img-box mr-4">
                                    <img
                                      src={
                                        item?.user_details &&
                                          item.user_details?.user_meta_info &&
                                          item.user_details.user_meta_info
                                            ?.profile_image === null
                                          ? "/assets/images/user.png"
                                          : item?.user_details &&
                                          item.user_details
                                            ?.user_meta_info &&
                                          item.user_details.user_meta_info
                                            ?.profile_image
                                      }
                                      alt="user img"
                                    />
                                  </div>
                                  <div className="content flex-grow-1">
                                    <h4 className="mb-0">
                                      {item?.user_details &&
                                        item.user_details?.full_name}
                                    </h4>
                                    <div className="d-flex flex-wrap align-items-center mt-2">
                                      {item?.skills &&
                                        Array.isArray(item?.skills) &&
                                        item.skills.map((tag) => (
                                          <>
                                            {tag?.is_primary === true ? (
                                              <div
                                                className={
                                                  "border rounded-pill text-nowrap text-grey-4 px-2 mr-2 text-capitalize mb-1"
                                                }
                                                key={tag?.id}
                                              >
                                                {tag?.skill_name}
                                              </div>
                                            ) : null}
                                          </>
                                        ))}
                                    </div>
                                  </div>
                                  <button className="bg-transparent border-0 ml-auto">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                  </button>
                                </li>
                              ))}
                          </ul>
                        ) : (
                          <EmptyFeedCard
                            src={"/assets/images/empty-state.svg"}
                            message={"No Candidates Found"}
                            btnText="View Candidates"
                            link="/all-candidates"
                          />
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>

              {/* Calendar Component */}
              <div className="col-xl-8 pb-4">
                <CalendarDashboardComponent />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={resumeUploadModal}
        centered
        onHide={() => handleResumeUploadModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Resume Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please Upload Your Resume</p>

          {isResumeUpload ? (
            <Spinner variant="primary" />
          ) : (
            <input
              className="form-control bg-transparent pb-2 h-auto"
              type="file"
              name="resume"
              accept=".pdf"
              onChange={onResumeUpload}
            />
          )}
        </Modal.Body>
      </Modal>
    </MainLayout>
  );
};
